import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

const PHONE = '07760 881212';
const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const BLOG_OG_IMAGE = 'https://public.readdy.ai/ai/img_res/46ec17f3262c82227fd45aab8bd382db.jpg';

const articles = [
  {
    id: 1,
    title: 'How Much Does House Rewiring Cost in Worksop?',
    excerpt: 'The cost of rewiring a house in Worksop depends on the size of the property and how much work is needed. In this guide, we break down typical costs and what\'s included so you know exactly what to expect.',
    category: 'Rewiring',
    readTime: '4 min read',
    date: '12 March 2026',
    image: 'https://readdy.ai/api/search-image?query=electrician%20rewiring%20house%20interior%20new%20electrical%20cables%20being%20installed%20in%20wall%20cavity%2C%20professional%20trade%20work%2C%20clean%20cable%20management%20and%20installation%20in%20modern%20UK%20home%2C%20bright%20interior%2C%20white%20walls%2C%20realistic%20photography&width=800&height=500&seq=blog-rewiring-cost-worksop&orientation=landscape',
    body: [
      'Rewiring a house is one of the biggest electrical jobs you can have done, and it\'s natural to want to know what it\'s going to cost. Prices in Worksop typically vary based on the size of your property, the age of your existing wiring, and how much disruption is involved.',
      '**Typical costs for rewiring in Worksop:**',
      '- 1-bedroom flat: £1,500 – £2,500\n- 2-bedroom house: £2,500 – £4,000\n- 3-bedroom house: £3,500 – £5,500\n- 4-bedroom house: £5,000 – £8,000+',
      'These are rough estimates — every property is different, so we always recommend booking a free no-obligation survey to get an accurate quote for your home.',
      '**What\'s included in a rewire?**',
      'A full rewire includes replacing all the cables, sockets, light fittings, and switches throughout your home. It also includes a new consumer unit (fuse board) and a full EICR test at the end to certify the work.',
      '**When do you need a rewire?**',
      'If your home has old rubber or aluminium wiring, round-pin sockets, a wooden fuse box, or is more than 30–40 years old without any electrical updates, it\'s likely time for a rewire. Our team covers all of Worksop and the surrounding area — give us a call for honest advice.',
    ],
  },
  {
    id: 2,
    title: 'Do I Need an EICR Certificate in the UK?',
    excerpt: 'An Electrical Installation Condition Report (EICR) is legally required for landlords in England and strongly recommended for all homeowners. Find out if you need one and exactly what\'s involved.',
    category: 'EICR',
    readTime: '3 min read',
    date: '5 March 2026',
    image: 'https://readdy.ai/api/search-image?query=electrician%20conducting%20electrical%20testing%20inspection%20with%20digital%20testing%20equipment%20holding%20clipboard%20with%20EICR%20test%20certificate%20paperwork%2C%20professional%20inspection%20in%20UK%20home%2C%20warm%20lighting%2C%20realistic%20trade%20photography&width=800&height=500&seq=blog-eicr-certificate-uk&orientation=landscape',
    body: [
      'An Electrical Installation Condition Report — commonly known as an EICR — is a formal document produced by a qualified electrician after a thorough inspection of your property\'s electrical systems.',
      '**Is an EICR legally required?**',
      'For landlords in England, yes. Since July 2020, all private landlords must have an EICR carried out every 5 years and provide a copy to their tenants. Failure to comply can result in a fine of up to £30,000.',
      'For homeowners, an EICR is not a legal requirement, but it is strongly recommended — especially when buying a house, before selling, or if your electrics are more than 10 years old.',
      '**What does the inspector check?**',
      'During an EICR inspection, your electrician will test all sockets, switches, circuits, the consumer unit, and earthing and bonding. The report will flag any issues as C1 (danger), C2 (potentially dangerous), or C3 (improvement recommended).',
      '**How much does an EICR cost in Worksop?**',
      'Typically between £100 and £200 depending on the size of the property. We offer competitive EICR pricing across Worksop, Retford, and surrounding areas. Call us today for a quote.',
    ],
  },
  {
    id: 3,
    title: 'Signs You Need to Upgrade Your Fuse Board',
    excerpt: 'If your fuse board is more than 25 years old or you\'re experiencing regular tripping, it may be time for an upgrade. Here are the warning signs homeowners in Worksop should look out for.',
    category: 'Fuse Board',
    readTime: '3 min read',
    date: '27 February 2026',
    image: 'https://readdy.ai/api/search-image?query=modern%20electrical%20consumer%20unit%20fuse%20board%20close%20up%20new%20white%20plastic%20consumer%20unit%20with%20circuit%20breakers%20installed%20on%20wall%20clean%20professional%20electrical%20installation%20in%20UK%20home%20bright%20lighting%20realistic%20photography&width=800&height=500&seq=blog-fuse-board-upgrade-signs&orientation=landscape',
    body: [
      'Your fuse board — also called a consumer unit — is the heart of your home\'s electrical system. An outdated or faulty fuse board can be a real safety hazard, and many homeowners don\'t realise theirs needs replacing until something goes wrong.',
      '**Warning signs you need a new fuse board:**',
      '- You have an old-style fuse board with ceramic fuses rather than modern circuit breakers\n- Fuses trip regularly or you\'re constantly having to reset them\n- You\'re adding new appliances and the circuits can\'t handle the load\n- Your board is over 25 years old\n- You\'re planning an extension or kitchen/bathroom renovation\n- You notice scorch marks or burning smells near the board',
      '**Why upgrade?**',
      'Modern consumer units come with RCDs (Residual Current Devices) which cut the power instantly in the event of a fault — protecting you and your family from electric shocks and fires. Older boards simply don\'t have this level of protection.',
      'A fuse board upgrade in Worksop typically takes half a day and starts from around £350. Get in touch with us for a free, no-obligation quote.',
    ],
  },
  {
    id: 4,
    title: 'How to Find a Reliable Emergency Electrician in Worksop',
    excerpt: 'Electrical emergencies don\'t wait for office hours. Here\'s what to look for when you need to find a trustworthy emergency electrician in Worksop fast — and the questions you should always ask.',
    category: 'Emergency',
    readTime: '4 min read',
    date: '18 February 2026',
    image: 'https://readdy.ai/api/search-image?query=professional%20electrician%20in%20safety%20workwear%20arriving%20at%20UK%20residential%20house%20for%20emergency%20call%20out%2C%20carrying%20tool%20bag%20and%20equipment%20at%20front%20door%2C%20daytime%20suburban%20street%20in%20Nottinghamshire%20England%2C%20realistic%20documentary%20photography&width=800&height=500&seq=blog-emergency-electrician-worksop&orientation=landscape',
    body: [
      'A power cut, burning smell, or sparking socket can be frightening — and in those moments you need someone you can trust to arrive quickly and fix the problem safely. But how do you find a reliable electrician in Worksop when time is short?',
      '**What to look for in an electrician:**',
      '- **NICEIC or NAPIT registered** — these are the main bodies that certify qualified electricians in the UK\n- **Part P registered** — required for notifiable electrical work in England\n- **Public liability insurance** — protects you if something goes wrong\n- **Local reviews** — check Google, Checkatrade, or Trustpilot for recent local feedback',
      '**Questions to ask before booking:**',
      'Always ask if they are registered with a competent persons scheme (NICEIC, NAPIT, or ELECSA), whether they can provide a written quote before starting work, and whether the job will be certified on completion.',
      '**Red flags to avoid:**',
      'Be wary of electricians who can\'t give you a registration number, refuse to provide a written quote, or ask for a large cash payment upfront with no paperwork.',
      'We cover Worksop and the surrounding area. You can reach us on ' + PHONE + '.',
    ],
  },
  {
    id: 5,
    title: 'What is Part P Building Regulations and Why Does It Matter?',
    excerpt: 'If you\'re having electrical work done in your home, Part P Building Regulations is something you need to know about. Here\'s a plain-English guide to what it means for homeowners in Worksop.',
    category: 'Regulations',
    readTime: '3 min read',
    date: '10 February 2026',
    image: 'https://readdy.ai/api/search-image?query=electrician%20writing%20in%20official%20certification%20paperwork%20clipboard%20at%20work%20desk%20with%20electrical%20tools%20and%20technical%20documentation%2C%20UK%20building%20regulations%20compliance%2C%20office%20lighting%2C%20realistic%20professional%20trade%20photography&width=800&height=500&seq=blog-part-p-regulations-uk&orientation=landscape',
    body: [
      'Part P of the UK Building Regulations covers electrical safety in domestic premises. It came into force in 2005 and requires that certain types of electrical work in homes must either be carried out by a registered electrician, or notified to and approved by your local building authority.',
      '**What work is notifiable under Part P?**',
      'The following work requires notification or must be done by a registered competent person:\n- New circuits in any location\n- Any electrical work in bathrooms, kitchens, or outdoors\n- Consumer unit (fuse board) replacements',
      'Smaller jobs like replacing a socket on an existing circuit in a bedroom are generally not notifiable.',
      '**Why does it matter to homeowners?**',
      'If you have electrical work done that should have been notified but wasn\'t, it can cause serious problems when you come to sell your home. Solicitors will ask for completion certificates, and without them you may have to apply for retrospective approval — which can be costly and delay your sale.',
      '**How do I know the work is compliant?**',
      'When you hire a registered electrician (NICEIC, NAPIT, or ELECSA), they self-certify the work and issue you with a completion certificate. This is your proof that the work meets building regulations — keep it safe with your other property documents.',
    ],
  },
  {
    id: 6,
    title: 'Common Electrical Problems in Older UK Homes',
    excerpt: 'Many homes across Worksop and Nottinghamshire were built decades ago, and their electrics haven\'t always kept up. Here are the most common electrical problems our team finds in older properties.',
    category: 'Safety',
    readTime: '5 min read',
    date: '3 February 2026',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20old%20outdated%20electrical%20wiring%20inside%20wall%20cavity%20with%20deteriorating%20rubber%20insulation%20cables%20alongside%20modern%20wiring%20comparison%20in%20traditional%20UK%20brick%20house%20interior%2C%20natural%20light%2C%20realistic%20documentary%20photography&width=800&height=500&seq=blog-old-home-electrical-problems&orientation=landscape',
    body: [
      'Older homes have a lot of character — but they can also come with electrical systems that simply weren\'t designed for modern living. Here are the most common issues our team encounters when working in older properties across the Worksop area.',
      '**1. Old rubber or fabric-sheathed wiring**',
      'Wiring from the 1960s and earlier was often insulated with rubber or braided fabric. Over time, this insulation cracks and crumbles, creating a serious fire and shock hazard. If you see this type of wiring in your home, it should be replaced as a priority.',
      '**2. Lack of earthing**',
      'Many older properties were wired without proper earth connections. Without earthing, there\'s no safe path for fault current — meaning a fault in an appliance could make the whole metal casing live.',
      '**3. Outdated consumer units**',
      'Old-style fuse boxes with rewireable ceramic fuses provide very limited protection compared to modern consumer units with MCBs and RCDs. They\'re also a fire risk if the fuses have been incorrectly rewired.',
      '**4. Overloaded circuits**',
      'Older homes were often wired with far fewer sockets than we use today. This leads to heavy reliance on extension leads and adapters, which can overload circuits and cause overheating.',
      '**5. No RCD protection**',
      'RCDs (Residual Current Devices) can save your life by cutting the power in milliseconds if a fault is detected. Many older properties have no RCD protection at all.',
      'If your home is showing any of these warning signs, it\'s worth getting a free inspection from our team. We\'re here to give you honest advice without the hard sell.',
    ],
  },
];

const categoryColors: Record<string, string> = {
  Rewiring: 'bg-orange-100 text-orange-700',
  EICR: 'bg-green-100 text-green-700',
  'Fuse Board': 'bg-blue-100 text-blue-800',
  Emergency: 'bg-red-100 text-red-700',
  Regulations: 'bg-purple-100 text-purple-700',
  Safety: 'bg-amber-100 text-amber-700',
};

const blogJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/blog#webpage`,
    url: `${siteUrl}/blog`,
    name: 'Electrical Advice Blog — Worksop Electrician Tips & Guides',
    description:
      'Helpful guides and tips from your local electrician in Worksop. Learn about rewiring costs, EICR certificates, fuse board upgrades and more electrical advice for UK homeowners.',
    isPartOf: { '@id': `${siteUrl}/#website` },
    about: { '@id': `${siteUrl}/#business` },
    inLanguage: 'en-GB',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    '@id': `${siteUrl}/blog#blog`,
    url: `${siteUrl}/blog`,
    name: 'Electrical Advice Blog — Worksop Electrician Tips & Guides',
    description:
      'Helpful guides and tips from your local electrician in Worksop. Learn about rewiring costs, EICR certificates, fuse board upgrades and more electrical advice for UK homeowners.',
    inLanguage: 'en-GB',
    publisher: { '@id': `${siteUrl}/#business` },
    blogPost: [
      {
        '@type': 'BlogPosting',
        headline: 'How Much Does House Rewiring Cost in Worksop?',
        description:
          'The cost of rewiring a house in Worksop depends on the size of the property and how much work is needed. A breakdown of typical costs and what\'s included.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-03-12',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'rewiring Worksop, house rewiring cost, electrician Worksop',
      },
      {
        '@type': 'BlogPosting',
        headline: 'Do I Need an EICR Certificate in the UK?',
        description:
          'An Electrical Installation Condition Report (EICR) is legally required for landlords in England and strongly recommended for all homeowners.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-03-05',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'EICR Worksop, EICR certificate UK, landlord electrical inspection',
      },
      {
        '@type': 'BlogPosting',
        headline: 'Signs You Need to Upgrade Your Fuse Board',
        description:
          'If your fuse board is more than 25 years old or you\'re experiencing regular tripping, it may be time for an upgrade.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-02-27',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'fuse board upgrade Worksop, consumer unit replacement, electrician Worksop',
      },
      {
        '@type': 'BlogPosting',
        headline: 'How to Find a Reliable Emergency Electrician in Worksop',
        description:
          'Electrical emergencies don\'t wait for office hours. Here\'s what to look for when you need a trustworthy emergency electrician in Worksop fast.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-02-18',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'emergency electrician Worksop, local electrician, electrical fault Worksop',
      },
      {
        '@type': 'BlogPosting',
        headline: 'What is Part P Building Regulations and Why Does It Matter?',
        description:
          'Part P of the UK Building Regulations covers electrical safety in domestic premises — a plain-English guide for homeowners in Worksop.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-02-10',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'Part P regulations UK, building regulations electrician, domestic electrical work',
      },
      {
        '@type': 'BlogPosting',
        headline: 'Common Electrical Problems in Older UK Homes',
        description:
          'Many homes across Worksop and Nottinghamshire were built decades ago. Here are the most common electrical problems our team finds in older properties.',
        url: `${siteUrl}/blog`,
        datePublished: '2026-02-03',
        author: { '@id': `${siteUrl}/#business` },
        publisher: { '@id': `${siteUrl}/#business` },
        keywords: 'old house electrics, rewiring Worksop, electrical safety UK',
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${siteUrl}/` },
      { '@type': 'ListItem', position: 2, name: 'Blog', item: `${siteUrl}/blog` },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'How much does house rewiring cost in Worksop?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Rewiring costs in Worksop typically range from £1,500–£2,500 for a 1-bed flat up to £5,000–£8,000+ for a 4-bedroom house. Every property is different — contact us for a free no-obligation survey.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I need an EICR certificate in the UK?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'For landlords in England, yes — an EICR is legally required every 5 years since July 2020. For homeowners it is strongly recommended when buying, selling, or if electrics are over 10 years old.',
        },
      },
      {
        '@type': 'Question',
        name: 'When do you need to upgrade your fuse board?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'You should upgrade your fuse board if it uses old ceramic wire fuses, is over 25 years old, trips frequently, or lacks RCD protection. Modern consumer units provide far greater safety.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is Part P Building Regulations?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Part P of the UK Building Regulations covers electrical safety in domestic premises. Certain electrical work must be carried out by a registered competent person (NICEIC, NAPIT, or ELECSA) who can self-certify the work.',
        },
      },
    ],
  },
];

function ArticleModal({ article, onClose }: { article: typeof articles[0]; onClose: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 overflow-y-auto py-10 px-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl max-w-3xl w-full mx-auto shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Image */}
        <div className="w-full h-64 overflow-hidden rounded-t-2xl">
          <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top" />
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="flex items-center gap-3 mb-4">
            <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${categoryColors[article.category]}`}>{article.category}</span>
            <span className="text-gray-400 text-xs">{article.readTime}</span>
            <span className="text-gray-400 text-xs">{article.date}</span>
          </div>
          <h2 className="font-heading font-extrabold text-2xl text-navy-800 mb-6 leading-snug">{article.title}</h2>

          <div className="prose prose-sm max-w-none text-gray-600 leading-relaxed space-y-4">
            {article.body.map((para, i) => {
              if (para.startsWith('**') && para.endsWith('**')) {
                return (
                  <h3 key={i} className="font-bold text-navy-800 text-base mt-6 mb-2">
                    {para.replace(/\*\*/g, '')}
                  </h3>
                );
              }
              if (para.includes('\n-')) {
                const [intro, ...items] = para.split('\n-');
                return (
                  <div key={i}>
                    {intro && <p className="mb-2">{intro}</p>}
                    <ul className="list-disc list-inside space-y-1.5 text-gray-600 text-sm">
                      {items.map((item, j) => (
                        <li key={j}>{item.replace(/^\*\*(.*?)\*\*/, (_, t) => t).trim()}</li>
                      ))}
                    </ul>
                  </div>
                );
              }
              return <p key={i} className="text-gray-600 text-sm leading-relaxed">{para}</p>;
            })}
          </div>

          {/* CTA */}
          <div className="mt-8 p-5 bg-amber-50 border border-amber-200 rounded-xl flex flex-col sm:flex-row items-center justify-between gap-4">
            <div>
              <p className="font-bold text-navy-800 text-sm">Need an electrician in Worksop?</p>
              <p className="text-gray-500 text-xs">Call us any time — we\'re always happy to help.</p>
            </div>
            <a
              href={`tel:${PHONE.replace(/\s/g, '')}`}
              className="flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-black font-extrabold text-sm px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </span>
              Call {PHONE}
            </a>
          </div>

          {/* Close */}
          <button
            onClick={onClose}
            className="mt-5 w-full text-center text-sm text-gray-400 hover:text-gray-600 cursor-pointer transition-colors"
          >
            &larr; Back to all articles
          </button>
        </div>
      </div>
    </div>
  );
}

export default function BlogPage() {
  const [activeArticle, setActiveArticle] = useState<typeof articles[0] | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('All');

  const categories = ['All', ...Array.from(new Set(articles.map((a) => a.category)))];
  const filtered = activeCategory === 'All' ? articles : articles.filter((a) => a.category === activeCategory);

  return (
    <>
      <SEOHead
        title="Electrical Advice Blog — Worksop Electrician Tips & Guides"
        description="Helpful guides and tips from your local electrician in Worksop. Learn about rewiring costs, EICR certificates, fuse board upgrades and more electrical advice for UK homeowners."
        keywords="electrician Worksop, rewiring Worksop, EICR Worksop, electrical advice UK, fuse board upgrade"
        canonical={`${siteUrl}/blog`}
        ogTitle="Electrical Advice Blog — Worksop Electrician Tips & Guides"
        ogDescription="Practical, honest electrical advice from your local Worksop electrician. No jargon — just the information you need about rewiring, EICR, fuse boards and more."
        ogUrl={`${siteUrl}/blog`}
        ogImage={BLOG_OG_IMAGE}
        jsonLd={blogJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl">
            <span className="inline-block bg-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-5">
              Electrical Advice
            </span>
            <h1 className="font-heading font-extrabold text-white mb-4" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Helpful Guides for Worksop Homeowners
            </h1>
            <p className="text-gray-400 text-lg leading-relaxed">
              Practical, honest advice from your local Worksop electrician. No jargon, no upselling — just the information you need to make the right decisions about your home's electrics.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="bg-white border-b border-gray-100 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-2 overflow-x-auto py-4 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap transition-all cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-amber-500 text-black'
                    : 'bg-gray-100 text-gray-600 hover:bg-amber-100 hover:text-amber-700'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          {/* Featured (first article) */}
          {activeCategory === 'All' && (
            <div
              className="mb-12 bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-amber-300 transition-all cursor-pointer group flex flex-col md:flex-row"
              onClick={() => setActiveArticle(articles[0])}
            >
              <div className="md:w-1/2 h-64 md:h-auto overflow-hidden">
                <img
                  src={articles[0].image}
                  alt={articles[0].title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="md:w-1/2 p-8 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${categoryColors[articles[0].category]}`}>{articles[0].category}</span>
                  <span className="text-gray-400 text-xs">{articles[0].readTime}</span>
                  <span className="text-gray-400 text-xs">{articles[0].date}</span>
                </div>
                <h2 className="font-heading font-extrabold text-navy-800 text-2xl leading-snug mb-4 group-hover:text-amber-600 transition-colors">
                  {articles[0].title}
                </h2>
                <p className="text-gray-500 text-sm leading-relaxed mb-6">{articles[0].excerpt}</p>
                <span className="inline-flex items-center gap-2 text-amber-600 font-bold text-sm">
                  Read full article
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </span>
              </div>
            </div>
          )}

          {/* Remaining Articles Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {(activeCategory === 'All' ? filtered.slice(1) : filtered).map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-amber-300 transition-all group cursor-pointer"
                onClick={() => setActiveArticle(article)}
              >
                <div className="w-full h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${categoryColors[article.category]}`}>{article.category}</span>
                    <span className="text-gray-400 text-xs">{article.readTime}</span>
                  </div>
                  <h3 className="font-heading font-bold text-navy-800 text-lg leading-snug mb-3 group-hover:text-amber-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{article.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-amber-600 font-bold text-xs">
                    Read more
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-amber-500 py-14">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-heading font-extrabold text-black text-2xl mb-2">Got a question about your electrics?</h2>
            <p className="text-black/70 text-base">We\'re always happy to give free, honest advice over the phone. No pushy sales — just a local tradesman you can trust.</p>
          </div>
          <a
            href={`tel:${PHONE.replace(/\s/g, '')}`}
            className="flex items-center gap-3 bg-black hover:bg-navy-800 text-amber-400 font-extrabold text-lg px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-phone-fill text-xl"></i>
            </span>
            {PHONE}
          </a>
        </div>
      </section>

      <Footer />

      {/* Article Modal */}
      {activeArticle && (
        <ArticleModal article={activeArticle} onClose={() => setActiveArticle(null)} />
      )}
    </>
  );
}
